import clsx from "clsx"
import dayjs from "dayjs"
import { useAppSelector } from "store"
import { useTranslation } from "react-i18next"
import { FC, useEffect, useState } from "react"
import { AppSelectors } from "store/slices/appSlice"
import { INFO_MODAL_TYPE } from "store/apis/infoModalsAPI/types"
import { useGetInfoModalReadQuery } from "store/apis/infoModalsAPI"
import { useHasUnclaimedMissionsQuery } from "store/apis/missionsAPI/missions.api"
import { useModals } from "context/modals/hooks/useModals"
import { useNyGift } from "hooks/useNyGift/useNyGift"
import { APP_ROUTES } from "utils/app-routes"
import { SideMenuMine } from "./ui/side-menu-mine"
import { SideMenuUnder } from "./ui/side-menu-under"
import { SideMenuAuction } from "./ui/side-menu-auction"
import { SideMenuSaleChest } from "./ui/side-menu-sale-chest"
import { SideMenuExpeditions } from "./ui/side-menu-expeditions"
import { ISideMenuItem, SideMenuItem } from "./ui/side-menu-item"
import { SideMenuWinterGift } from "./ui/side-menu-winter-gift/SideMenuWinterGift"
import {
  MenuRefsIcon,
  // letterIcon,
  steelMissionChestIcon,
  storeIcon,
  tutorial
} from "assets/icons"
import styles from "./index.module.scss"

interface ISideMenuProps {
  items?: ISideMenuItem[]
}

export const SideMenu: FC<ISideMenuProps> = ({ items }) => {
  const { t } = useTranslation()
  const { openModal } = useModals()

  const isUnder = useAppSelector(AppSelectors.selectIsUnder())

  const [nav, setNav] = useState<ISideMenuItem[]>([])

  const { data, isLoading: isLoadingTutorial } = useGetInfoModalReadQuery({
    type: INFO_MODAL_TYPE.TUTORIAL,
    lang: "en"
  })

  const { data: unclaimedData } = useHasUnclaimedMissionsQuery()
  const hasUnclaimedMissions = unclaimedData?.hasUnclaimed ?? false

  const { isVisibleGift } = useNyGift()

  useEffect(() => {
    const navItems: ISideMenuItem[] = []

    if (
      !isUnder &&
      !isLoadingTutorial &&
      dayjs().diff(data?.redAt, "day") <= 7
    ) {
      navItems.push({
        id: "btn-tutorial",
        name: "tutorial",
        color: "#FED080",
        icon: tutorial,
        title: t("tutorial"),
        onClick: () => {
          openModal("onboarding")
        }
      })
    }

    if (!isUnder) {
      navItems.push(
        {
          id: "btn-store",
          name: "store",
          color: "#FFB47F",
          icon: storeIcon,
          title: t("store"),
          link: APP_ROUTES.STORE
        },
        {
          name: "missions",
          color: "#BDC6C9",
          icon: steelMissionChestIcon,
          title: t("missions"),
          link: APP_ROUTES.QUESTS("missions"),
          hasIndicator: hasUnclaimedMissions
        },
        // {
        //   name: "quests",
        //   color: "#FFD180",
        //   icon: letterIcon,
        //   title: t("quests"),
        //   link: APP_ROUTES.QUESTS()
        // },
        {
          name: "referrals",
          color: "#B9A0BA",
          icon: MenuRefsIcon,
          title: t("refs"),
          link: "/referrals/details"
        }
      )
    }

    setNav(navItems)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoadingTutorial, isUnder, hasUnclaimedMissions, t])

  return (
    <aside id="side-menu" className={clsx(styles.SideMenu)}>
      <div className={clsx(styles.SideMenu_top)}>
        {!isUnder && (
          <>
            <SideMenuSaleChest />
            <SideMenuMine />
            <SideMenuExpeditions />
          </>
        )}
        <SideMenuAuction />
        <SideMenuUnder />
      </div>
      <div className={clsx(styles.SideMenu_list)}>
        {isVisibleGift && <SideMenuWinterGift />}
        {(items ?? nav).map((e) => (
          <SideMenuItem {...e} key={e.name} />
        ))}
      </div>
    </aside>
  )
}

export default SideMenu
